import "../css/App.css";

const Footer = () => {
    return (
        <footer className="footer" style={{ fontSize: "1rem" }}>
            <p style={{ width: "90%" }}>&copy; {new Date().getFullYear()} SOLE – Servants of Our Lady of Evangelization</p>
        </footer>
    );
};
export default Footer;
